

































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({
  name: "video-timeline-settings-menu",
})
export default class VideoTimelineSettingsMenu extends Vue {
  @Prop() value!: boolean
  @Prop() scale!: number

  setScale(scale: string) {
    this.$emit('scaleInput', scale)
  }

  saveScale(scale: string) {
    this.$emit('scaleChange', scale)
  }

  getMenuWidth() {
    if (this.$parent.$el)
      return `${this.$parent.$el.getBoundingClientRect().width - 12}px`
    else
      return ''
  }
}
